import { CanActivateFn, Router } from '@angular/router';
import { UtilCatService } from '../../../shared/utils/UtilCatService';
import { inject } from '@angular/core';

export const roleGuard: CanActivateFn = (route, state) => {
  const _router = inject(Router);
  if (UtilCatService.getAllowedRoutes(state.url)) {
    return true;
  } else {
    _router.navigateByUrl('/error');
    return false;
  }
};
